import { Change, diffLines, diffWords } from "diff";

interface IProps {
    oldText: string;
    newText: string;
}



const SideBySideDiff = ({ oldText, newText }: IProps) => {
    const lineDiffs = diffLines(oldText, newText);

    let oldLineNum = 1;
    let newLineNum = 1;

    const renderWordDiff = (oldLine: string, newLine: string) => {
        const wordDiff = diffWords(oldLine, newLine);
        return wordDiff.map((part, index) => (
            <span
                key={index}
                style={{
                    // backgroundColor: part.removed ? "salmon" : part.added ? "lightgreen" : "transparent",
                    // textDecoration: part.removed ? "line-through" : "none",
                    whiteSpace: "pre-wrap",
                    backgroundColor: oldLine ? (part.added ? "#C0C0C0" : part.removed ? "salmon" : "transparent") : (part.added ? "salmon" : part.removed ? "#C0C0C0" : "transparent"),

                }}
            >
                {part.value}
            </span>
        ));
    };

    const renderDiff = (diff: Change[], isOld: boolean) => {
        return diff.map((part, index) => {
            const lines = part.value.split(/\r\n|\n/);
            return (
                <div key={index}>
                    {lines.map((line, lineIndex) => {
                        const lineNumber = isOld ? oldLineNum : newLineNum;
                        // if (!part.removed) isOld ? oldLineNum++ : newLineNum++; // Increment only if not removed
                        if (isOld) {
                            if (!part.added) oldLineNum++;
                        } else {
                            if (!part.removed) newLineNum++;
                        }

                        // Check if the line is changed instead of fully removed or added
                        const correspondingNewLine =
                            isOld && diff[index + 1] && diff[index + 1].added ? diff[index + 1].value : null;

                        // if ((isOld && part.removed && !correspondingNewLine)
                        //   || (!isOld && part.removed && !correspondingNewLine)

                        // )
                        //   return undefined
                        // else
                        return (
                            <div key={lineIndex} style={{ display: "flex", gap: "10px" }}>
                                <span style={{ width: "30px", textAlign: "right", color: "#888" }}>
                                    {/* {lineNumber} */}
                                    {/* {part.removed 
                    ? "-"
                    : part.added 
                      ? "+"
                      : ""} */}
                                    {/* {part.removed && isOld
                    ? "-"
                    : part.added && !isOld
                      ? "+"
                      : ""} */}
                                    {(correspondingNewLine && isOld) || (!correspondingNewLine && !isOld)
                                        ? lineNumber
                                        : part.removed && isOld
                                            ? "-"
                                            : part.removed
                                                ? ""
                                                : part.added && !isOld
                                                    ? "+"
                                                    : part.added
                                                        ? ""
                                                        : lineNumber}
                                    {/* {part.removed && isOld
                    ? "✖"
                    : part.added && !isOld
                      ? "➕"
                      : lineNumber} */}
                                </span>
                                <span style={{
                                    whiteSpace: "pre-wrap",
                                    backgroundColor: isOld ? (part.added ? "#C0C0C0" : part.removed ? "salmon" : "transparent") : (part.added ? "lightgreen" : part.removed ? "#C0C0C0" : "transparent"),
                                    color: isOld ? (part.added ? "transparent" : 'black') : (part.removed ? "transparent" : 'black'),
                                    // display : isOld && part.added && !correspondingNewLine ? "none" : "inline"
                                }}>
                                    {/* {part.added || part.removed
                    ? line // Directly show added or removed lines
                    : renderWordDiff(line, lines[lineIndex] || "")} Word diff for unchanged lines */}
                                    {part.removed || part.added
                                        ? correspondingNewLine
                                            ? renderWordDiff(line, correspondingNewLine.split(/\r\n|\n/)[lineIndex] || "")
                                            : line // If no corresponding line, show removed/added as-is
                                        : line}
                                </span>
                            </div>
                        );
                    })}
                </div>
            );
        });
    };

    return (
        <div style={{ display: "flex", fontFamily: "monospace", whiteSpace: "pre-wrap" }}>
            {/* Original Text Side */}
            <div style={{ flex: 1, padding: "10px", borderRight: "1px solid #ccc" }}>
                <h4>Antes da Alteração</h4>
                {renderDiff(lineDiffs, true)}
            </div>

            {/* Modified Text Side */}
            <div style={{ flex: 1, padding: "10px" }}>
                <h4>Após a Alteração</h4>
                {renderDiff(lineDiffs, false)}
            </div>
        </div>
    );
};


export default SideBySideDiff;
